import React, { useRef, useEffect } from 'react';
import DataTableInput from '../../../Input/input';

const Quantity = ({ focus, active, disabled, row, elementFocused, handleQuantity }) => {
    const qtyInput = useRef(null);

    const onBlurQTY = (e) => {
        handleQuantity(e.target.value, row)
    }

    const quantitySelectKeyDown = e => {
        if (e.key === 'Delete') {//e.key === 'Backspace' || 
            handleQuantity(null, row)
        }
    }

    let displayValue = '';
    if (row.Quantity) displayValue = row.Quantity;
    if (row.Coding.length > 1) displayValue = row.Coding.reduce((acc, cur) => acc + Number(cur.Quantity ? cur.Quantity : 0), 0);

    useEffect(() => {
        if (!disabled && qtyInput.current) {
            if (active)
                qtyInput.current.focus();
            else
                qtyInput.current.blur();
        }
    }, [active, qtyInput])

    return <DataTableInput
        inputElementType="text"
        inputAcceptType="number"
        elementId={row.BankDataGUID + `_qty`}
        value={displayValue}
        onBlur={onBlurQTY}
        onFocus={elementFocused}
        elementRef={qtyInput}
        disabled={disabled}
        onKeyDown={quantitySelectKeyDown}
    />
}

export default Quantity;


// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/Quantity/quantity.js